import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc';


const WorkflowListDumb = ({
  handleSearch,
  searchValue,
  handleCreate,
  handleEdit,
  handleView,
  handleDelete,
  handleRunJob,
  content,
  options,
  isLoaded,
  defaultValues,
  validPermission
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues("project");
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (workflow) => {
    handleDelete(workflow);
  };

  const onEdit = (workflow) => {
    handleEdit(workflow);
  };

  const onView = (workflow) => {
    handleView(workflow);
  };

  const onRunJob = (workflow) => {
    handleRunJob(workflow);
  };

  const columns = [
    { label: t('common.components.table.col.name'), key: 'name' },
    { label: t('common.components.table.col.description'), key: 'description' },
  ];

  const createActions = () => {
    const actions = [];

    if (validPermission(projectId, 'isExecute')) actions.push({
      label: t('workflowList.components.table.run'),
      icon: <PlayCircleOutlineOutlinedIcon color='primary' />,
      handle: onRunJob
    });
    if (validPermission(projectId, 'isVisible')) actions.push({
      label: t('common.components.buttons.view'),
      icon: <VisibilityOutlinedIcon color="primary" />,
      handle: onView,
    });
    if (validPermission(projectId, 'isEdit')) actions.push({
      label: t('workflowList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit,
    });
    if (validPermission(projectId, 'isDelete')) actions.push({
      label: t('workflowList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    });

    return actions;
  }

  const actions = createActions();

  return (
    <>
      <HeadlinePage
        title="workflowList.headline"
        buttonLabel={validPermission(projectId, 'isCreate') ? "workflowList.components.add" : ""}
        handleOnClick={handleCreate}
      />
      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        options={options}
        searchValue={searchValue}
      />
      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="workflowList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  );
};

export default withPermission(WorkflowListDumb, "workflow");
